import { ErrorFallback } from 'components/errors/error-boundary';
import { Content } from 'components/layout/content';
import { FC } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router-dom';

const EmptyLayout: FC = () => {
  const logError = (error: Error, info: { componentStack: string }) => {
    console.log(`Error: ${error}  Stack: ${info.componentStack}`);
  };

  return (
    <div className="d-flex flex-column flex-root">
      <div id="kt_content" className="content d-flex flex-column flex-column-fluid">
        <ErrorBoundary FallbackComponent={ErrorFallback} onError={logError}>
          <Content>
            <Outlet />
          </Content>
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default EmptyLayout;
